import { render, staticRenderFns } from "./recordDay.vue?vue&type=template&id=70f9125a&scoped=true&"
import script from "./recordDay.vue?vue&type=script&lang=js&"
export * from "./recordDay.vue?vue&type=script&lang=js&"
import style0 from "./recordDay.vue?vue&type=style&index=0&id=70f9125a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9125a",
  null
  
)

export default component.exports